import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { COMMISSION_STATUS } from '../enums';

@Pipe({
  name: 'agentCommissionStatus'
})
export class AgentCommissionStatusPipe extends EnumConverter implements PipeTransform {
  enumeration = COMMISSION_STATUS;
}
